import { baseApi } from "api/BaseApi";

import { PublicLabgram } from "./labgrams.types";

const LABGRAM_BASE_URL = "lab/labgrams";

const labgramApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicLabgrams: build.query<PublicLabgram[], void>({
      query: () => ({
        url: `${LABGRAM_BASE_URL}/get_frontend_labgrams/`,
      }),
    }),

    getPublicLabgram: build.query<PublicLabgram, string | number>({
      query: (id) => ({
        url: `${LABGRAM_BASE_URL}/${id}/public/`,
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useGetPublicLabgramsQuery, useGetPublicLabgramQuery } =
  labgramApi;
